import type { DropdownOption } from "@stenajs-webui/select";
import { components, type OptionProps } from "react-select";

import { CountryDropdownContent } from "./CountryDropdownContent";

export const CountryDropdownOption = <
  TValue extends DropdownOption<{ value: string; label: string }>,
>({
  children,
  ...optionProps
}: OptionProps<TValue, false>) => (
  <components.Option {...optionProps}>
    <CountryDropdownContent countryCode={optionProps.data.value.toLowerCase()}>
      {children}
    </CountryDropdownContent>
  </components.Option>
);
